import { endOfDay, startOfDay } from 'date-fns';

export function mapStartDateToApi(startDate: string | undefined) {
    try {
        if (!startDate) return;
        return startOfDay(new Date(startDate)).toISOString();
    } catch {
        //no-empty
    }
}

export function mapEndDateToApi(endDate: string | undefined) {
    try {
        if (!endDate) return;
        return endOfDay(new Date(endDate)).toISOString();
    } catch {
        //no-empty
    }
}
